import { FC } from "react";

import { PatientLookupModalProps } from "./types";
import { format } from "date-fns";



const PatientLookupModal: FC<PatientLookupModalProps> = ({ isModalVisible, patientPrevCaseDate, totalRefills, caseDataSubmission, clearCaseData }): JSX.Element => {
  return (
    <div
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      id="exampleModal"
      tabIndex={-1}
      data-bs-backdrop="static"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '700px'}}>
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title fs-5" id="exampleModalLabel">Warning</h2>
          </div>

          <div className="modal-body">
            <p className="m-0">
              An order was submitted for this patient on 
              {patientPrevCaseDate.length > 0 ? format(new Date(patientPrevCaseDate), "MM/dd/yyyy") : ""}{' '}with
              {' '}<span className="fw-bold">{totalRefills} refills</span>,
              would you like to reorder Afrezzafor this patient?
            </p>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={clearCaseData}>No, take me back to the dashboard</button>
            <button type="button" className="btn btn-secondary" onClick={caseDataSubmission}>Yes, finish now</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatientLookupModal
